export default "__VITE_ASSET__67dd754e__"